import React from "react";
import StoreManagementTable from "./StoreManagementTable";

const StoreManagement = () => {

  return <div>{<StoreManagementTable />}</div>;
};

export default StoreManagement;
